import { post, parseData } from '../api/common';
import { responseHandler } from '../api/api';
const getDataInterchangeConfig = (DataInterchangePK) => post('/InternalAPI/DataInterchangeAPI.asmx/GetDataInterchangeMapping', {
    DataInterchangePK
})
    .then(parseData)
    .then(responseHandler);
const createDataInterchangeConfig = (DataInterchange) => post('/InternalAPI/DataInterchangeAPI.asmx/CreateDataInterchangeMapping', {
    DataInterchange
})
    .then(parseData)
    .then(responseHandler);
const updateDataInterchangeConfig = (DataInterchange) => post('/InternalAPI/DataInterchangeAPI.asmx/UpdateDataInterchangeMapping', {
    DataInterchange
})
    .then(parseData)
    .then(responseHandler);
const getDITypeConfiguration = (Type) => post('/InternalAPI/DataInterchangeAPI.asmx/GetDITypeConfiguration', {
    Type
})
    .then(parseData)
    .then(responseHandler);
const getDataInterchangeTypeStatues = () => post('/InternalAPI/DataInterchangeAPI.asmx/GetDataInterchangeTypeStatuses')
    .then(parseData)
    .then(responseHandler);
export { getDataInterchangeConfig, createDataInterchangeConfig, updateDataInterchangeConfig, getDITypeConfiguration, getDataInterchangeTypeStatues };
